import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box } from '@mui/material'
import React from 'react'
import { SettingsBox } from 'src/Elements/Data'
import { NumberField } from 'src/Libs/inputs/react-hook-form'
import Toggle from 'src/Libs/inputs/react-hook-form/Toggle/Toggle'
import { UnitTypes } from 'src/Libs/types'
import { useInstallationAccessRightsContext } from 'src/Libs/installation-rights-management/provider/InstallationAccessRightsContext'

type EmergencyPowerComponent = React.FC<{ children: React.ReactNode }> & {
  EmergencyPowerToggle: typeof EmergencyPowerToggle
  Delay: typeof Delay
  Reserve: typeof Reserve
}

const EmergencyPower: EmergencyPowerComponent = ({ children }) => {
  const { t } = useCustomTranslation()

  return (
    <Box component="section">
      <SettingsBox title={t('installation.storageEditor.emergencyPower.title')} description={t('installation.storageEditor.emergencyPower.hint')}>
        {children}
      </SettingsBox>
    </Box>
  )
}

const EmergencyPowerToggle: React.FC = () => {
  const { t } = useCustomTranslation()
  const { hasInstallationWritingRights: canEdit } = useInstallationAccessRightsContext()

  return (
    <SettingsBox
      title={t('installation.storageEditor.emergencyPower.useEmergencyPower')}
      suffix={
        <Toggle
          name="storageSystem.generalSettings.advancedSettings.emergencyPower.useEmergencyPower"
          label={t('installation.storageEditor.emergencyPower.cheackPartialGridFailure')}
          disabled={!canEdit}
        />
      }
      depth={1}
    />
  )
}

const Delay: React.FC = () => {
  const { t } = useCustomTranslation()
  const { hasInstallationWritingRights: canEdit } = useInstallationAccessRightsContext()

  return (
    <SettingsBox
      title={t('installation.storageEditor.emergencyPower.delay')}
      suffix={
        <NumberField
          name="storageSystem.generalSettings.advancedSettings.emergencyPower.emergencyPowerDelay"
          label={t('installation.storageEditor.emergencyPower.delay')}
          suffix={UnitTypes.second}
          inputProps={{ min: 0, max: 60 }}
          disabled={!canEdit}
        />
      }
      depth={1}
    />
  )
}

const Reserve: React.FC<{ storageIndex: number }> = ({ storageIndex }) => {
  const { t } = useCustomTranslation()
  const { hasInstallationWritingRights: canEdit } = useInstallationAccessRightsContext()

  return (
    <SettingsBox
      title={t('installation.storageEditor.emergencyPower.reserve')}
      suffix={
        <NumberField
          name={`storageSystem.storageSpecificSettings.${storageIndex}.advancedSettings.emergencyPower.emergencyPowerReserve`}
          label={t('installation.storageEditor.emergencyPower.reserve')}
          suffix={UnitTypes.wattHour}
          inputProps={{ min: 0, max: 20_000 }}
          disabled={!canEdit}
        />
      }
      depth={1}
    />
  )
}

EmergencyPower.EmergencyPowerToggle = EmergencyPowerToggle
EmergencyPower.Delay = Delay
EmergencyPower.Reserve = Reserve

export default EmergencyPower
